import { PlayerEditFormPart } from 'modules/players/domain/constants/player-card';
import { TeamEditFormPart } from 'modules/teams/ui/components/team-view-tabs/constants';
import { TourneyEditFormPart } from 'modules/tournaments/ui/components/edit-form/constants';

export const Pages = {
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  SELECT_TOURNAMENT: '/select-tournament',
  INDEX: '/',
  ABOUT: '/about',
  POLICY: '/policy',
  TERMS: '/terms',
  SETTINGS: {
    INDEX: '/settings',
    SOCIAL_NET: '/settings/social-net',
  },
  ORGANIZER: {
    CREATE: '/organizer/create',
  },
  TEMPLATE: {
    INDEX: '/template/',
    BOARDS: '/template/:templateId/boards',
    EDITOR: '/template/:templateId/boards/:boardId',
    PREVIEW: '/template/:templateId/boards/:boardId/preview',
    builders: {
      boards: (templateId: number) => `/template/${templateId}/boards`,
      editor: (templateId: number, boardId: number) => `/template/${templateId}/boards/${boardId}`,
      preview: (templateId: number, boardId: number) => `/template/${templateId}/boards/${boardId}/preview`,
    },
    CATALOG: {
      INDEX: '/template/catalog',
      CARD: '/template/catalog/:id',
      builders: {
        card: (id: number) => `/template/catalog/${id}`,
      },
    },
  },
  SUPPORT: '/support',
  TOURNEYS: {
    INDEX: '/tourneys',
    CREATE: '/tourneys/create/common',
    EDIT: '/tourneys/:id',
    builders: {
      edit: (id: number, hash: string = TourneyEditFormPart.COMMON.hash) => `/tourneys/${id}/${hash}`,
    },
  },
  GAMES: 'games',
  TEAMS: {
    INDEX: '/teams/',
    CREATE: '/teams/create',
    EDIT: '/teams/:id',
    builders: {
      edit: (id: number, hash: string = TeamEditFormPart.COMMON.hash) => `/teams/${id}/${hash}`,
    },
  },
  OVERLAY: {
    INDEX: '/cover/:matchId',
    CONTROL_PANEL: '/control-panel/:matchId',
  },
  OVERLAY_V2: {
    INDEX: 'organizer/:organizerId/device/:deviceId/overlay',
    builders: {
      index: (organizerId: string, deviceId: string, token: string) =>
        `/organizer/${organizerId}/device/${deviceId}/overlay?token=${token}`,
    },
  },
  COVER: '/cover/:matchId',
  ORGANIZERS: {
    INDEX: '/organizers/',
    VIEW: '/organizers/:id',
    builders: {
      view: (id: number) => `/organizers/${id}`,
    },
  },
  SCHEDULE: {
    INDEX: '/schedule/',
    VIEW: '/schedule/:id',
    builders: {
      view: (id: number) => `/schedule/${id}`,
    },
  },
  PLAYERS: {
    INDEX: '/players/',
    VIEW: '/players/:id',
    CREATE: '/players/create/',
    builders: {
      view: (id: number, hash: string = PlayerEditFormPart.COMMON.hash) => `/players/${id}/${hash}`,
    },
  },
  MASTER_BOARDS: {
    INDEX: '/master-board',
    CONTROL_PANEL: '/master-board/control-panel/:id?',
    BOARD: '/master-board/board/:id?',
    builders: {
      controlPanel: (id: string) => `/master-board/control-panel${id ? `/${id}` : ''}`,
      board: (id: string) => `/master-board/board${id ? `/${id}` : ''}`,
    },
  },
  LOCATIONS: {
    INDEX: '/locations',
    CREATE: '/locations/create',
    VIEW: '/locations/:id',
    builders: {
      edit: (id: number) => `/locations/${id}`,
    },
  },
  APPLICATION_LINK: {
    INDEX: '/application-link',
    SUCCESS: '/success',
  },
  NOTIFICATIONS: {
    INDEX: '/notifications',
    CREATE: '/notifications/create',
    EDIT: '/notifications/edit/:id',
    builders: {
      edit: (id: number) => `/notifications/edit/${id}`,
    },
  },
  CHAMPIONSHIPS_TEST: '/championships-test',
  TESTS: {
    INDEX: '/test-components',
    COMPONENTS: '/test-components',
    COMPONENT: '/test-components/:componentName',
    PLAYERS: '/tests/players',
    FABRIC_EDITOR_DEMO: '/test-components/fabric-editor',
    builders: {
      component: (componentName: string) => `/test-components/${componentName}`,
    },
  },
  MIGRATION: {
    INDEX: '/migration',
  },
  CLIENT_TOURNAMENT: {
    VIEW_CHAMPIONSHIP: '/client-tournament/:idTournament/:idChampionship',
    builders: {
      viewChampionship: (idTournament: number, idChampionship: number) => `/client-tournament/${idTournament}/${idChampionship}`,
    },
  },
  ROLES_MANAGER: {
    INDEX: '/roles-manager',
    builders: {
      index: () => `/roles-manager`,
    },
  },
  DEVICES: {
    INDEX: '/devices',
  },
  ANALYTICS: {
    INDEX: '/analytics',
  },
  MEDIA_MANAGER: {
    INDEX: '/manager',
    EDITOR: '/manager/templates/:templateId',
    RENDER: '/manager/render',
    RENDER_STANDINGS: '/manager/render-standings',
    builders: {
      editor: (templateId: number) => `/manager/templates/${templateId}`,
      render: (params: {
        tournamentId: number;
        championshipId: number;
        matchId: number;
        templateId: number;
        bgUrls?: string[];
      }) => {
        const search = new URLSearchParams({
          tournamentId: String(params.tournamentId),
          championshipId: String(params.championshipId),
          matchId: String(params.matchId),
          templateId: String(params.templateId),
        });
        params.bgUrls?.forEach((url, i) => search.append(`bg${i + 1}`, url));
        return `/manager/render?${search.toString()}`;
      },
      renderStandings: (params: { stageId: number; templateId: number; bgUrls?: string[] }) => {
        const search = new URLSearchParams({
          stageId: String(params.stageId),
          templateId: String(params.templateId),
        });
        params.bgUrls?.forEach((url, i) => search.append(`bg${i + 1}`, url));
        return `/manager/render-standings?${search.toString()}`;
      },
    },
  },
};
